module.exports = __webpack_public_path__ + "static/media/favicon.c92b85a5.ico";